import { Injectable } from "@angular/core";
import {
  MatDialog as MatDialog,
  MatDialogConfig as MatDialogConfig,
} from "@angular/material/dialog";
import { ConfirmationDialogComponent } from "./confirmation-dialog/confirmation-dialog.component";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class ConfirmationService {
  constructor(public dialog: MatDialog) {}

  confirm(details: ConfirmationDetails) {
    // Pop the dialog
    const config: MatDialogConfig = {
      data: {
        title: details.title,
        buttonLabel: details.buttonLabel,
        destructiveButton: details.destructiveButton
          ? details.destructiveButton
          : false,
        content: details.message,
        confirmable: details.confirmable,
        ...(details.onConfirmAsync
          ? {
              confirmAction: details.onConfirmAsync,
              pendingLabel: details.pendingLabel,
              failureMessage: details.failureMessage,
              onConfirmError: details.onConfirmError,
            }
          : {}),
      },
      panelClass: "dialog-container",
    };
    const dialogReference = this.dialog.open(
      ConfirmationDialogComponent,
      config,
    );

    // Handle the result
    dialogReference.afterClosed().subscribe((result) => {
      this.onConfirm(result, details);
    });
  }

  onConfirm(confirmed: boolean, details: ConfirmationDetails) {
    if (confirmed) {
      if (details.onConfirm) {
        details.onConfirm();
      }
    } else {
      if (details.onCancel) {
        details.onCancel();
      }
    }
  }
}

export class ConfirmationDetails {
  title: string;
  message: string;
  buttonLabel: string;
  destructiveButton?: boolean;
  confirmable = true;
  onConfirm: () => void;
  onCancel: () => void;
  onConfirmAsync?: () => Observable<unknown>;
  pendingLabel?: string;
  failureMessage?: string;
  onConfirmError?: (error: unknown) => void;
}
